import { useMediaQuery } from '@mui/material';
import { numberWithSpaces } from '../../components/utils';
import { motion } from 'framer-motion';
import style from './style.module.scss';

const PopupSuccess = ({ close, userData }) => {
    const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`);

    const popupVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    const contentVariants = {
        hidden: { scale: isMobile ? 1 : 0.8, x: isMobile ? 0 : '-50%', y: isMobile ? 10 : '-40%' },
        visible: { scale: 1, x: isMobile ? 0 : '-50%', y: isMobile ? 0 : '-50%' },
    };

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={popupVariants}
            transition={{ duration: 0.1 }}
            className={style.popup}
        >
            <div className={style.overlay} onClick={close} />
            <motion.div
                className={style.content}
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={contentVariants}
                transition={{ duration: 0.1 }}
            >
                <div className={style.gift}>🎁</div>

                <div className={style.reward}>
                    <div className={style.text}>Félicitation !</div>
                    <div className={style.points}>+100 pts.</div>
                </div>

                <div className={style.score}>
                    <div className={style.text}>Mon solde de points</div>
                    <div className={style.value}>{numberWithSpaces(userData.points)} pts.</div>
                </div>

                <div className={style.progress}>
                    <div className={style.current}>
                        <img src={userData.rank.current.image} alt={userData.rank.current.name} />
                        <div className={style.label}>
                            Niveau <span>{userData.rank.current.name}</span>
                        </div>
                    </div>
                    <div className={style.gaugeContainer}>
                        <div className={style.gauge} style={{ width: userData.percent + '%' }}>
                            <div
                                className={style.value}
                                style={{
                                    left: userData.percent >= 15 ? 'auto' : '9px',
                                    right: userData.percent >= 15 ? '9px' : 'auto',
                                }}
                            >
                                {userData.percent}%
                            </div>
                        </div>
                    </div>
                    <div className={style.next}>
                        <img src={userData.rank.next.image} alt={userData.rank.next.name} />
                        <div className={style.label}>
                            Niveau <span>{userData.rank.next.name}</span>
                        </div>
                    </div>
                </div>

                <div className={style.textProfil}>
                    {isMobile
                        ? 'Continuer de jouer pour gagner des points !'
                        : 'Continuer de compléter votre profil pour gagner des points !'}
                </div>

                <div className={style.action}>
                    <a href={'/concours'} className={'button-myhand-big'}>
                        Je continue de jouer !
                    </a>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default PopupSuccess;
